import React from 'react';
import './TimeBox.css';
import ClockIcon from '../../Assets/Icons/Clock.png'
import { useTranslation } from 'react-i18next';

const TimeBox = ({ time }) => {
  const { t } = useTranslation();

  return (
    <div className="time-container">
      <img src={ClockIcon} alt="icon" className="time-box-icon" />
      <span className="time-box-time">{time} {t("min")}</span>
    </div>
  );
};

export default TimeBox;
